// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8188":"990457da747107d3","9950":"060787d11cea7316"}[chunkId] + ".css";
};